import {Component, OnInit, Output, EventEmitter, Input, Attribute} from '@angular/core';
import {StsCmsService} from '../../../services/sts-cms-service.service';
import {forkJoin, of} from 'rxjs';

@Component({
  selector: 'app-sts-section-body',
  templateUrl: './sts-section-body.component.html',
  styleUrls: ['./sts-section-body.component.scss']
})
export class StsSectionBodyComponent implements OnInit {

  @Input() key: string;
  @Output() renderingComplete = new EventEmitter<boolean>(false);

  public showSection: boolean = false;
  public showRegLink: boolean = false;
  public styles = {'font-weight': 'bold'};

  constructor(private cmsService: StsCmsService,
              @Attribute('Content') private Content,
              @Attribute('regPrefix') private regPrefix,
              @Attribute('regTitle') private regTitle,
              @Attribute('regSuffix') private regSuffix,
  ) {}

  ngOnInit() {
    let requests = [];
    // if attr is found on template, we'll try to read corresponding label from CMS, otherwise default to empty string
    requests.push(this.Content != null ? this.cmsService.getText('sts-sectionBodyContent-' + this.key) : of(""));
    requests.push(this.regPrefix != null ? this.cmsService.getText('sts-sectionBody-registrationPrefix-' + this.key) : of(""));
    requests.push(this.regTitle != null ? this.cmsService.getText('sts-sectionBody-registrationTitle') : of(""));
    requests.push(this.regSuffix != null ? this.cmsService.getText('sts-sectionBody-registrationSuffix-' + this.key) : of(""));
    forkJoin(requests).subscribe(res => {
      this.Content = res[0] || "";
      this.regPrefix = res[1] || "";
      this.regTitle = res[2] || "";
      this.regSuffix = res[3] || "";
      this.showSection = !!this.key || !!this.Content || (!!this.regPrefix && !!this.regTitle && !!this.regSuffix);
      this.showRegLink = !!this.regPrefix && !!this.regSuffix;
      this.renderingComplete.emit(true);
    });
  }

}
